import FigmaBadge from '../Elements/FigmaBadge';
import React from 'react';

export default class CommissionRateOverrideItem {
  constructor(item) {
    if (item === undefined) {
      this.CommissionRateId = null;
      this.UserId = null;
      this.CommissionYearPeriod = null;
      this.Rate = null;
      this.CurrencyId = null;
      this.StartedOn = new Date();
      return;
    }
    this.CommissionRateId = item.commissionRateId;
    this.UserId = item.userId;
    this.CommissionYearPeriod = item.commissionYearPeriod;
    this.Rate = item.rate;
    this.CurrencyId = item.currencyId;
    this.CurrencyCode = item.currencyCode;
    this.StartedOn = item.startedOn;
    this.ClosedOn = item.closedOn;
    this.CreatedOn = item.createdOn;
    this.IsActive = item.isActive;
  }

  static MoneyFields = [];

  static Currency() {
    return '';
  }

  static DateFields = ['ClosedOn', 'StartedOn'];

  static BoolFields = [];

  static FieldsToShowInDataTable() {
    return [
      { label: 'Selected', orderById: '', data: CommissionRateOverrideItem.getSelectedCellContent, minWidth: 20 },
      { label: 'Commission Rate ID', orderById: 'CommissionRateId', data: 'CommissionRateId', minWidth: 20 },
      { label: 'Rate', orderById: 'Rate', data: (item) => `${item.Rate}%` },
      { label: 'Currency', orderById: 'CurrencyCode', data: 'CurrencyCode' },
      { label: 'Start Date', orderById: 'StartedOn', data: 'StartedOn' },
      { label: 'Close Date', orderById: 'ClosedOn', data: 'ClosedOn' },
      { label: 'Is Active?', orderById: 'IsActive', data: (item) => <FigmaBadge Active={item.IsActive} /> },
    ];
  }

  static getSelectedCellContent(item) {
    if (item.Selected === undefined) item.Selected = false;
    return (
      <div className='text-center'>
        <input
          type='radio'
          checked={item.Selected}
          onClick={(e) => {
            CommissionRateOverrideItem.clickOnSelect(item);
          }}
          onChange={(e) => {}} //Don't remove. This is necessary to eliminate the React warning!
        />
      </div>
    );
  }

  static clickOnSelect(item) {
    alert('Click');
  }
}
